import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { error } from 'console';
import { CompetenciesService } from '../competencies.service';
import { CompetencyData, CompetencyLeaderStream, CompetencyManagerRoleType, Manager, OrgChartModel } from 'src/app/Models/organizationModel.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SubCompetenciesSidebarComponent } from '../sub-competencies-sidebar/sub-competencies-sidebar.component';
import { OthersService } from '../others/othersDataService';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { GsdRoles } from 'src/app/enums/gsdRoles.enum';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { dialogflow } from 'googleapis/build/src/apis/dialogflow';
import { EmployeeService } from '../../employee-profile/employee-profile.service';
import { SharedSkillService } from '../../skill-repository/shared-skill.service';

@Component({
  selector: 'app-org-chart',
  templateUrl: './org-chart.component.html',
  styleUrls: ['./org-chart.component.css'],
})
export class OrgChartComponent implements OnInit {
  @ViewChild('updateManager') updateDialog = {} as TemplateRef<string>;
  dialogRef: any;
  @Input() subcompetenciesSidebarComponent: SubCompetenciesSidebarComponent;
  data: OrgChartModel;
  updatingdata: CompetencyData
  names: any[] = [];
  managerRoles: string[] = [];
  peopleStream: any[] = [];
  functionalStream: any[] = [];
  technicalStream: any[] = [];
  competencyId: any;
  competencyName: any
  subCompetencyName: string;
  userRole: string = this.auth.getRole();
  editedManagerName: string = '';
  role: string;
  adminRole: number = 1;
  isManagerDetailsEdited: boolean = false;
  filteredValues: any[] = [];
  selectedEmployee: any;
  manager: Manager;
  isEmployeeEditable = false;
  updateManagerInfo: any;
  maximizeLayout: any

  constructor(public sharedSkillService: SharedSkillService, private employeeService: EmployeeService, private orgChartService: CompetenciesService, private othersService: OthersService, private route: ActivatedRoute, private auth: AuthServiceService, public dialog: MatDialog, private router: Router) { }
  ngOnInit() {

    this.orgChartService.competencyName$.subscribe(value => {
      this.competencyName = value;
    })
    this.othersService.maximizeLayout$.subscribe(value => {
      this.maximizeLayout = value
    })
    this.orgChartService.profileStatus$.subscribe(value => {
      this.competencyId = value;
    })
    this.othersService.name$.subscribe(names => {
      this.subCompetencyName = names;
      this.handleIdChange();
    });
    this.role = this.auth.getRole();

    if (this.role.includes(GsdRoles.SuperAdmin)) {

      this.adminRole = 0;

    }

    this.isEmployeeEditable = this.sharedSkillService.getIsEditable();
    this.role = this.auth.getRole();

    if (this.role.includes(GsdRoles.SuperAdmin)) {

      this.adminRole = 0;
      this.isEmployeeEditable = true;

    }

  }

  handleIdChange() {

    this.fetchEmployees();

  }

  ngOnChanges() {

    this.fetchEmployees();

  }

  openDialog(managerupdate: any): void {

    this.updateManagerInfo = {

      managerupdate
    }

    this.dialogRef = this.dialog.open(this.updateDialog,

      {

        data: this.updateManagerInfo, height: '32em', width: '30em',

      }
    );
    this.dialogRef.afterClosed().subscribe(result => {
    })

  }

  getMoveItStyles() {

    return { 'margin-right': this.othersService.maximizeLayout$ ? '0px' : '0px' }

  }

  setCurrentEmployee(employeeId: any) {

    this.selectedEmployee = this.filteredValues.find(employee => employee.employeeId === employeeId);
    if (this.selectedEmployee) {
      this.updateEmployeeDetails(this.selectedEmployee);
      this.isManagerDetailsEdited = true;
    }

  }

  updateEmployeeDetails(selectedEmployee: any) {

    this.manager.name = selectedEmployee.name;
    this.manager.id = selectedEmployee.employeeId;

  }

  getFilteredValues(event: any) {

    this.employeeService.getEmployeesOnSearch(event).subscribe((res) => {
      this.filteredValues = res.data ? res.data.profiles : [];
    });

  }



  fetchEmployees() {

    this.orgChartService.getOrgChartEmployeeshierarchy(this.competencyId, this.subCompetencyName).subscribe(
      (response: any) => {
        this.data = response.data;
        this.extractManagerRoles();
      },

      (error: any) => {
        console.log('Error occurred while fetching data from the API:', error);
      }
    );

  }

  getInitials(name: string): string {
    let names = name.split(" ");
    let firstName = names[0];
    let lastName = names[names.length - 1];
    return firstName[0] + lastName[0];
  }

  extractManagerRoles() {

    this.managerRoles = Array.from(new Set(this.data.managers.map((manager: Manager) => this.getManagerRoleName(manager.managerRoleType))));
    this.peopleStream = [];
    this.functionalStream = [];
    this.technicalStream = [];

    for (let role of this.managerRoles) {
      switch (role.toLowerCase()) {
        case "skill maturity manager":
        case "resource manager":
        case "hiring manager":
        case "group technical manager":
          this.peopleStream.push(role);
          break;

        case "tools and frameworks spoc":
        case "design and development spoc":
        case "architecture spoc":
        case "emerging technology spoc":
        case "tech audit":
          this.functionalStream.push(role);
          break;

        case "newsletter enabler":
        case "kms enabler":
        case "certification enabler":
        case "accelerators and ip enabler":
        case "interview panel enabler":
          this.technicalStream.push(role);
          break;
        default:
          this.peopleStream.push(role);
          break;
      }
    }

  }

  getManagerRoleName(managerRoleType: CompetencyManagerRoleType) {

    switch (managerRoleType) {

      case CompetencyManagerRoleType.SkillMaturityManager: return "Skill Maturity Manager";
      case CompetencyManagerRoleType.ResourceManager: return "Resource Manager"
      case CompetencyManagerRoleType.InterviewPanelEnabler: return "Interview Panel Enabler"
      case CompetencyManagerRoleType.HiringManager: return "Hiring Manager"
      case CompetencyManagerRoleType.GroupTechnicalManager: return "Group Technical Manager"
      case CompetencyManagerRoleType.CertificationEnabler: return "Certification Enabler"
      case CompetencyManagerRoleType.KMSEnabler: return "KMS Enabler"
      case CompetencyManagerRoleType.AcceleratorsAndIPEnabler: return "Accelerators And IP Enabler"
      case CompetencyManagerRoleType.NewsLetterEnabler: return "NewsLetter Enabler"
      case CompetencyManagerRoleType.EmergingTechnologySPOC: return "Emerging Technology SPOC"
      case CompetencyManagerRoleType.ArchitectureSPOC: return "Architecture SPOC"
      case CompetencyManagerRoleType.DesignAndDevelopmentSPOC: return "Design And Development SPOC"
      case CompetencyManagerRoleType.ToolsAndFrameworksSPOC: return "Tools And Frameworks SPOC"
      case CompetencyManagerRoleType.TechAudit: return "Tech Audit"

    }
  }



  getManagersByRole(role: string): Manager[] {
    return this.data.managers.filter(
      (manager: Manager) => this.getManagerRoleName(manager.managerRoleType) === role
    );
  }

  getLocationIds() {
    const locationIds = [];
    for (const manager of this.data.managers) {
      const locationId = manager.locationId;
      if (!locationIds.includes(locationId)) {
        locationIds.push(locationId);
      }
    }
    return locationIds.sort((a, b) => a - b);
  }

  locationFlagMap: { [locationName: string]: string } = {
    'APAC - Hyderabad': 'IN',
    'APAC - Chennai': 'IN',
    'APAC - Noida': 'IN',
    'APAC - Taiwan': 'TW',
    'Americas - USA': 'US',
  }

  getLocationName(locationId: number): string {
    const locationMap = {
      1: 'APAC - Hyderabad ', 2: 'APAC - Chennai', 3: 'APAC - Noida', 4: 'APAC - Taiwan', 5: 'Americas - USA',
    };
    return locationMap[locationId] || 'Unknown Location';
  }

  getFlagName(locationName: string): string {
    const parts = locationName.split('-');
    return parts[1];
  }

  getManagersByLocation(locationId: number): Manager[] {
    return this.data.managers.filter((manager: Manager) => manager.locationId === locationId);
  }

  getManagersByRoleAndLocation(role: string, locationId: number): any[] {
    return this.data.managers.filter((manager: any) => this.getManagerRoleName(manager.managerRoleType) === role && manager.locationId === locationId);
  }

  onUpdate() {
    if (this.updateManagerInfo) {
      let updatedData: CompetencyData = {
        competencyId: this.competencyId,
        competencyName: this.competencyName,
        globalCompetencyLeader: [{
          id: this.data.globalCompetencyLeader[0].id,
          name: this.data.globalCompetencyLeader[0].name
        }
        ],
        subCompetencyLeaders: [
          {
            subCompetencyName: this.subCompetencyName,
            globalSubCompetencyLeader: [{
              id: this.data.globalSubCompetencyLeader[0].id,
              name: this.data.globalSubCompetencyLeader[0].name,
            }
            ],
            locationManagers: [
              {
                locationId: this.updateManagerInfo.managerupdate.locationId,
                location: this.updateManagerInfo.managerupdate.location,
                managerStream: this.updateManagerInfo.managerupdate.managerStream,
                managerRoleType: this.updateManagerInfo.managerupdate.managerRoleType,
                id: this.selectedEmployee.employeeId,
                name: this.selectedEmployee.name
              }
            ]
          }
        ]
      };
      this.orgChartService.updateCompetencyLeaderHierarchy(updatedData).subscribe(
        response => {
          console.log('POST request successful:', response);
        },
        error => {
          console.error('Error in POST request:', error);
        }
      );
      this.dialogRef.close();
    }
    setTimeout(() => {
      this.fetchEmployees();
    }, 150);
  }

  openDialogToAdd(role: string, locationId: number) {

    let managerRoleTypeValue: CompetencyManagerRoleType

    switch (role.toLowerCase()) {

      case "skill maturity manager": managerRoleTypeValue = CompetencyManagerRoleType.SkillMaturityManager
        break;

      case "resource manager": managerRoleTypeValue = CompetencyManagerRoleType.ResourceManager
        break;

      case "group technical manager": managerRoleTypeValue = CompetencyManagerRoleType.GroupTechnicalManager
        break;

      case "hiring manager": managerRoleTypeValue = CompetencyManagerRoleType.HiringManager
        break;

      case "tools and frameworks spoc": managerRoleTypeValue = CompetencyManagerRoleType.ToolsAndFrameworksSPOC
        break;

      case "design and development spoc": managerRoleTypeValue = CompetencyManagerRoleType.DesignAndDevelopmentSPOC
        break;

      case "architecture spoc": managerRoleTypeValue = CompetencyManagerRoleType.ArchitectureSPOC
        break;

      case "emerging technology spoc": managerRoleTypeValue = CompetencyManagerRoleType.EmergingTechnologySPOC
        break;

      case "tech audit": managerRoleTypeValue = CompetencyManagerRoleType.TechAudit
        break;

      case "newsletter enabler": managerRoleTypeValue = CompetencyManagerRoleType.NewsLetterEnabler
        break;

      case "kms enabler": managerRoleTypeValue = CompetencyManagerRoleType.KMSEnabler
        break;

      case "certification enabler": managerRoleTypeValue = CompetencyManagerRoleType.CertificationEnabler
        break;

      case "accelerators and ip enabler": managerRoleTypeValue = CompetencyManagerRoleType.AcceleratorsAndIPEnabler
        break;
      case "interview panel enabler": managerRoleTypeValue = CompetencyManagerRoleType.InterviewPanelEnabler
        break;
    }

    this.updateManagerInfo = {
      managerupdate: {
        locationId: locationId,
        location: this.getLocationName(locationId),
        managerRoleType: managerRoleTypeValue,
        id: '',
        name: ''
      }
    };
    this.dialogRef = this.dialog.open(this.updateDialog, {
      data: this.updateManagerInfo,
      height: '32em',
      width: '30em'
    });
    this.dialogRef.afterClosed().subscribe(result => {
    });
  }


  shouldDecreaseFontSize(text: string): boolean {
    return text.length > 23;
  }

}
